module.exports = __webpack_public_path__ + "hero-next-2295-24a66a44d17140eb998d8505a6fce020.bundle.webp";